export class GameModes {
  static readonly GAME_MODE_STUDY = 'Study Mode';
  static readonly GAME_MODE_PLAY = 'Play Mode';
}
